
export const COLORS = {
    primary: "#d68028",
  };